import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
  inject,
} from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import { TransferStatus, TransferType } from '@fitness-force/enum';
import type { TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TENANTS_INFO } from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'transfer-actions',
  templateUrl: './transfer-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, PopoverModule, TranslateModule, AsyncPipe],
})
export class TransferActionsComponent implements OnInit {
  private authService = inject(AuthSevices);
  private store = inject(Store);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null); // expected data ["edit","active","inactive"] etc
  rowIndex: number = 0;

  readonly onAction = output<{
    action: string;
    columnData: any;
    rowIndex: number;
  }>(); // {type:actionName,columnData }
  showOptions: boolean = false;
  currentUserDetails: any;
  tenantId: number = 0;

  ngOnInit(): void {
    this.currentUserDetails = this.authService.decodedToken;
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
    });
  }

  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({
      action,
      columnData: columnData,
      rowIndex: this.rowIndex,
    });
  }

  isActive(columnData: any): boolean {
    return columnData.status.toUpperCase() == 'Active'.toUpperCase();
  }

  isStatusVoid(columnData: any): boolean {
    return columnData.status.toLowerCase() == 'void';
  }

  ShowDecline(columnData: any) {
    if (
      columnData.transfer_type == TransferType.LocationToLocation ||
      columnData.transfer_type == TransferType[TransferType.LocationToLocation]
    ) {
      if (this.tenantId == columnData.transfer_to_tenant_id) return true;
      else return false;
    } else return false;
  }

  ShowVoid(columnData: any) {
    if (this.tenantId == columnData.transfer_from_tenant_id) return true;
    else return false;
  }

  ShowStart(columnData: any) {
    if (
      columnData.transfer_type == TransferType.LocationToLocation ||
      columnData.transfer_type == TransferType[TransferType.LocationToLocation]
    ) {
      if (this.tenantId == columnData.transfer_to_tenant_id) return true;
      else return false;
    } else return false;
  }

  showActions(columnData: any): boolean {
    return (
      columnData.transfer_status !== TransferStatus.Decline &&
      columnData.transfer_status.toString() !==
        TransferStatus[TransferStatus.Decline] &&
      columnData.transfer_status !== TransferStatus.Completed &&
      columnData.transfer_status.toString() !==
        TransferStatus[TransferStatus.Completed] &&
      columnData.transfer_status !== TransferStatus.Void &&
      columnData.transfer_status.toString() !==
        TransferStatus[TransferStatus.Void]
    );
  }

  get hasAdminBilling(): boolean {
    return this.currentUserDetails.can_admin_billing == 'true' ? true : false;
  }
}
